import { render, staticRenderFns } from "./BasketDetails.vue?vue&type=template&id=75877536"
import script from "./BasketDetails.vue?vue&type=script&lang=js"
export * from "./BasketDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports